import React, { useState } from "react";
import { FiX, FiZap } from "react-icons/fi";

const AnnouncementBar = () => {
  const [visible, setVisible] = useState(true);
  if (!visible) return null;

  return (
    <div className="relative overflow-hidden bg-gradient-to-r from-brand-700 via-brand-600 to-brand-700 text-white text-center text-sm py-2.5 px-4">
      {/* Animated shimmer layer */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent animate-shimmer" style={{ backgroundSize: "200% 100%" }} />
      <span className="relative flex items-center justify-center gap-2 font-sans">
        <FiZap size={13} className="text-accent-400 animate-glow-pulse" />
        <span>
          Free shipping on orders over $99 &nbsp;·&nbsp; Premium compact electronics &nbsp;·&nbsp;
          <strong className="font-display"> storeonline.online</strong>
        </span>
        <FiZap size={13} className="text-accent-400 animate-glow-pulse" />
      </span>
      <button
        onClick={() => setVisible(false)}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-white/60 hover:text-white transition-colors"
        aria-label="Dismiss"
      >
        <FiX size={15} />
      </button>
    </div>
  );
};

export default AnnouncementBar;
